import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

import { useActions } from '@mssgme/hooks';
import { EnhancedNavigationGuard, EnhancedFormik, Form, TextField, SaveButton } from '@mssgme/ui';
import { useDomain } from './hooks';
import DomainLayout from './DomainLayout';
import Help from './Help';

export default function DomainEdit() {
    const { t } = useTranslation('cards');
    const domain = useDomain();
    const actions = useActions();
    const [redirectTo, setRedirectTo] = useState();

    return (
        <EnhancedFormik
            initialValues={{ name: domain.name }}
            onSubmit={async (values) => {
                if (domain.name && !values.name) {
                    await actions.api.card.domain.disconnect();
                    setRedirectTo('/p/settings');
                } else {
                    await actions.api.card.domain.connect({
                        payload: values,
                    });
                    setRedirectTo('/p/settings/url/domain/change-dns');
                }
            }}
        >
            <EnhancedNavigationGuard>
                {redirectTo && <Redirect to={redirectTo} />}
                <DomainLayout rightButton={<SaveButton />}>
                    <Form>
                        <TextField id="domain.name" name="name" placeholder="www.example.com" autoFocus />
                        <Help>
                            <p dangerouslySetInnerHTML={{ __html: t('domain.enter_domain') }} />
                        </Help>
                    </Form>
                </DomainLayout>
            </EnhancedNavigationGuard>
        </EnhancedFormik>
    );
}
